import Container from './container';
import presentModal from './actions/present';
import dismissModal from './actions/dismiss';
import isModalPresented from './helpers/is-presented';

export { Container, presentModal, dismissModal, isModalPresented };
